import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import styles from './style.module.scss';

const Button = ({
  title,
  onClick,
  isDisabled,
  theme = 'primary',
  isFullWidth,
  isLoading,
}) => {
  return (
    <div className={styles.container}>
      <button
        type="button"
        className={twMerge(
          clsx(
            isDisabled && theme === 'primary' && styles.primaryDisabled,
            !isDisabled && theme === 'primary' && styles.primary,
            isDisabled && theme === 'secondary' && styles.secondaryDisabled,
            !isDisabled && theme === 'secondary' && styles.secondary,
            isFullWidth && styles.isFullWidth,
          ),
        )}
        onClick={onClick}
        disabled={isDisabled}>
        {isLoading && <span className={styles.loader} />}
        {title}
      </button>
    </div>
  );
};

export default Button;
